import { render } from "./HeroiconsOutlineInboxIn.vue?vue&type=template&id=611d796c"
const script = {}

import exportComponent from "/Users/crynobone/Projects/laravel/nova/aries/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineInboxIn.vue"]])

export default __exports__